import { createClient } from "@supabase/supabase-js";
import { runtimeConfig } from "@/config/runtime-config";

export const supabase = createClient(
  runtimeConfig.supabaseUrl,
  runtimeConfig.supabasePublishableKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  },
);
